import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const TheHelperBees: EmploymentType = {
	company: 'The Helper Bees',
	position: 'Staff Software Engineer',
	objective: 'A company that provides seniors with tools to help them age-in-place.',
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/The Helper Bees.png',
};
